import { CommunicationWindowSchema, OUTBOUND_CALL_AND_SMS_ALLOWED_COUNTRIES } from 'notable-common';
import { z } from 'zod';
import { FlowDurationUnits } from '../../../duration/duration.js';
import { FlowDurationSchemaWithMax } from '../../../duration/withMax.js';
import { FlowRunExecutionMode } from '../../../flowRun/executionMode.js';
import { FlowBlockValueUsPhoneNumberSchema } from '../../blockValue/phoneNumberSchema.js';
import { BaseFlowBlockSchema } from '../block.js';
import { FlowBlockType } from '../type.js';
export const FlowSendSmsBlockConfigSchema = z.object({
    calleePhoneNumber: FlowBlockValueUsPhoneNumberSchema({
        isRequired: true,
        allowedCountries: OUTBOUND_CALL_AND_SMS_ALLOWED_COUNTRIES,
    }),
    callerPhoneNumberId: z.uuid('Must be a valid phone number configuration id.').nullish(),
    message: z.string().min(1, 'This field is required.'),
    timeout: FlowDurationSchemaWithMax({
        pathName: 'value',
        max: { value: 60, units: FlowDurationUnits.Minutes },
    }),
    runMode: z
        .enum(
    /* eslint-disable-next-line @typescript-eslint/no-deprecated -- the block schema must reference the deprecated run-execution mode while it remains supported */
    FlowRunExecutionMode)
        .optional()
        .default(
    /* eslint-disable-next-line @typescript-eslint/no-deprecated -- the block schema must reference the deprecated run-execution mode while it remains supported */
    FlowRunExecutionMode.Live),
    communicationWindow: CommunicationWindowSchema.optional(),
});
export const FlowSendSmsBlockSchema = BaseFlowBlockSchema.extend({
    type: z.literal(FlowBlockType.SendSms),
    config: FlowSendSmsBlockConfigSchema,
});
//# sourceMappingURL=config.js.map